import useJwt from '@/libs/auth/jwt/useJwt'
import axios from '@axios'

const { jwt } = useJwt(axios, {
    loginEndpoint: '/auth/login',
    refreshEndpoint: '/auth/refresh-tokens',
})

export default jwt
